module.exports = __webpack_public_path__ + "img/password-gray.0de9d77c.svg";